const styles = {
  wrapper: 'mb-4 text-h3 lg:text-h4 xl:text-h3 text-pink',
};

export default styles;
